<template lang="pug">
div
  h4.mr-3 Configuración de Webhooks
  p Para configurar la integración con tus sistemas, debes registrar aquí un webhook con la URL de tu sistema.
  p Cada vez que ocurra un cambio de estado en un envío, nosotros te enviarem una solicitud POST a tu URL con la información del envío.
  p Puedes encontrar más información de los eventos en la sección de webhook en la documentación de la API, puedes descargarla &nbsp;
    a(href="Envios_now_API_Docs.pdf" target="_blank" style="color: #007bff;") aquí
    |.
  p Recuerda que debes responder a esta solicitud con un código de estado HTTP 200 para que nosotros podamos saber que la solicitud ha sido recibida.
  div.mb-2.mt-4(style="display: flex; justify-content: space-between; align-items: center; max-width: 100%;")
    h5 Tus Webhooks
    b-button(
      v-b-modal.webhook-form
      size="sm"
    ) Crear Webhook
  b-table(:items="tableItems" :fields="fields")
    template(#cell(actions)="{ item }")
      div(style="display: flex; align-items: center; gap: 8px;")
        .material-icons-outlined.text-primary(
          @click="copyUrl(item.webhookUrl)"
          style="cursor: pointer;"
        ) copy
        .material-icons-outlined.text-danger(
          @click="handleDeleteWebhook(item.id)"
          style="cursor: pointer;"
        ) delete
    template(#cell(isActive)="{ item }")
      b-form-checkbox(
        v-model="item.isActive"
        variant="primary"
        switch
        @change="toggleActive(item)"
      )
  div(
    v-if="rowCount === 0 && !loadingWebhooks"
    class="text-center"
  ) No se encontraron Webhooks
  b-pagination(
    v-else
    align="center"
    :per-page="rowsPerPage"
    :total-rows="rowCount"
    v-model="currentPage"
    @input="fetchWebhooks"
  )
  WebhookForm(
    @done="fetchWebhooks"
  )
</template>

<script>
import WebhookForm from './WebhookForm.vue'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  components: {
    WebhookForm
  },
  data () {
    return {
      webhooks: [],
      loadingWebhooks: false,
      fields: [
        { key: 'webhookUrl', label: 'URL' },
        { key: 'isActive', label: 'Activo' },
        { key: 'humanizeLastUsedAt', label: 'Último uso' },
        { key: 'actions', label: 'Acciones' }
      ],
      rowsPerPage: 5,
      currentPage: 1,
      rowCount: 0
    }
  },
  computed: {
    totalPages () {
      return Math.ceil(this.rowCount / this.rowsPerPage) || 1
    },
    tableItems () {
      return this.webhooks.map(webhook => ({
        ...webhook,
        humanizeLastUsedAt: webhook.lastUsedAt ? moment(webhook.lastUsedAt).format('DD-MM-YYYY HH:mm') : 'Nunca'
      }))
    }
  },
  methods: {
    ...mapActions(['getWebhooks', 'updateWebhook', 'deleteWebhook', 'createWebhook']),
    copyUrl (url) {
      navigator.clipboard.writeText(url)
      this.$bvToast.toast('URL copiada exitosamente', {
        title: 'Éxito',
        variant: 'success'
      })
    },
    async fetchWebhooks () {
      this.loadingWebhooks = true
      try {
        const params = {
          limit: this.rowsPerPage,
          offset: (this.currentPage - 1) * this.rowsPerPage
        }
        const response = await this.getWebhooks({ params })
        this.webhooks = response.data.rows
        this.rowCount = response.data.count
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingWebhooks = false
      }
    },
    async toggleActive (item) {
      try {
        await this.updateWebhook({ id: item.id, data: { isActive: item.isActive } })
        this.$bvToast.toast('Webhook actualizada exitosamente', {
          title: 'Éxito',
          variant: 'success'
        })
      } catch (error) {
        console.error(error)
      }
    },
    async handleDeleteWebhook (id) {
      const ok = await this.$bvModal.msgBoxConfirm('¿Estás seguro de eliminar este Webhook?', {
        title: 'Eliminar Webhook',
        okVariant: 'danger',
        cancelVariant: 'secondary',
        okTitle: 'Eliminar',
        cancelTitle: 'Cancelar'
      })
      if (!ok) return

      try {
        await this.deleteWebhook(id)
        this.$bvToast.toast('Webhook eliminada exitosamente', {
          title: 'Éxito',
          variant: 'success'
        })
        this.fetchWebhooks()
      } catch (error) {
        console.error(error)
      }
    }
  },
  mounted () {
    this.fetchWebhooks()
  }
}
</script>
